import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = [ "availableImageList", "availableImage", "assignedImageList", "assignedImage", "imageTemplate", "previewSlides" ];
  static outlets = [ "sortable" ];

  connect() {
    this.counter = 0;
    this.previewImages = [];
    this.previewModal = new Modal(document.getElementById("previewModal"));
    this.slidesTimer = {};
    this.interval = 5000;

    // Boostrap modals can be closed without clicking the "close" button.
    // So we need to listen for the event in order to reset the modal content
    document.addEventListener('hidden.bs.modal', this.modalCloseHandler.bind(this));

    this.update();
  }

  dragover(event) {
    event.preventDefault();
    return true;
  }

  dragstart(event) {
    this.draggedItem = event.currentTarget;
    this.draggedItem.classList.add("active");
  }

  dragend() {
    this.draggedItem.classList.remove("active");
    this.assignedImageListTarget.classList.remove("droppable");
  }

  dragenter() {
    this.assignedImageListTarget.classList.add("droppable");
    this.counter++;
  }

  dragleave() {    
    this.counter--;
    if (this.counter === 0) {
      this.assignedImageListTarget.classList.remove("droppable");
    }
  }

  drop(event) {
    event.preventDefault();

    this.counter = 0;
    this.assignedImageListTarget.classList.remove("droppable");
    this.draggedItem.classList.remove("active");

    if (event.currentTarget.classList.contains('dropzone')) {
      if (this.draggedItem.classList.contains("added")) return false;
      this.add(this.draggedItem);
    }
  }

  add(el) {
    const imageName = el.getAttribute('data-image-name');
    const imageURL = el.getAttribute('data-image-url');
    const imageId = el.getAttribute('data-image-id');

    const assignedImage = this.assignedImageTargets.find(assignedImage => {
      return assignedImage.getAttribute('data-image-id') === imageId;
    });

    if (assignedImage) {
      // if the image exists within the assigned list but is marked to be deleted, rescind the deletion.  
      const deleteMarker = assignedImage.querySelector('input.destroyer');
      deleteMarker.value = '0';
      assignedImage.classList.remove("marked-for-delete");
    } else {
      // otherwide, its not in the list, so add it.
      var text = this.imageTemplateTarget.innerHTML;
      text = text.replaceAll('{{imageName}}', imageName);
      text = text.replaceAll('{{imageTag}}', `<img src="${imageURL}" alt="${imageName}" />`);
      text = text.replaceAll('{{imageId}}', imageId);
      text = text.replaceAll('{{imageURL}}', imageURL);

      this.assignedImageListTarget.insertAdjacentHTML('beforeend', text);
    }
    this.update();
  }

  remove(event) {
    const image = event.currentTarget.closest(".screen-saver-image");
    const deleteMarker = image.querySelector('input.destroyer');

    if (deleteMarker) {
      // the element is a persisted one, so we need to mark it for deletion on the server.
      deleteMarker.value = '1';
      image.classList.add("marked-for-delete");
    } else {
      // the element is a newly added one during this render, so it can be just removed.
      image.remove();
    }

    this.update();
  }

  update() {
    // ensure that any images that already exist within the assigned images hide them within the available images.
    const currentImageIds = this.assignedImageTargets.map(image => {
      const deleteMarker = image.querySelector('input.destroyer');

      if (deleteMarker && deleteMarker.value === '1') {
        // if the item has been marked for deletion, don't include it in the list to suppress.
        return null;
      } else {
        return image.getAttribute('data-image-id');
      }
    });

    // manage visibility of available images.
    this.availableImageTargets.forEach(image => {
      const imageId = image.getAttribute('data-image-id');
      if (currentImageIds.includes(imageId)) {
        image.style.display = 'none';
      } else {
        image.style.display = 'block';
      }
    });

    // renumber the assigned images.
    this.assignedImageTargets.forEach((image, index) => {
      const number = index + 1;

      const inputs = image.querySelectorAll('input');
      inputs.forEach(input => {
        const name = input.getAttribute('name');
        input.setAttribute('name', name.replace(/\[\d+\]/, `[${number}]`));
        const id = input.getAttribute('id');
        input.setAttribute('id', id.replace(/_\d+_/, `_${number}_`));
      });
    });
    

    // ask the sortable controller to sort the assigned images.
    this.sortableOutlet.end();
  }

  preview() {
    let activeImages = document.querySelectorAll('.dropzone .screen-saver-image:not(.marked-for-delete)');

    if (activeImages.length > 0) {
      this.previewModal.show();
      this.buildPreviewSlides(activeImages);
      this.startRotation();
    }
  }

  buildPreviewSlides(images) {
    images.forEach((image) => {
      const imageURL = image.getAttribute("data-image-url");
      let newSlide = document.createElement("div");
      newSlide.className = "slide";
      newSlide.style.backgroundImage = `url('${imageURL}')`;
      this.previewSlidesTarget.appendChild(newSlide);
    })
  }

  modalCloseHandler() {
    this.previewSlidesTarget.innerHTML = "";
    window.clearInterval(this.slidesTimer);
  }

  startRotation() {
    const slides = this.previewSlidesTarget.querySelectorAll(".slide");
    slides[0].classList.add("active");

    if (slides.length > 1) {
      this.slidesTimer = window.setInterval(() => {
        const activeSlide = this.previewSlidesTarget.querySelector(".slide.active");
        const nextSlide = activeSlide.nextElementSibling || slides[0];
        activeSlide.classList.remove("active");
        nextSlide.classList.add("active");
      }, this.interval);
    }
  }
}
